import { getConfig } from "../../../../config/app";

const basePath = getConfig("basePath");
const path = basePath === "/" ? "" : basePath;

export const getResultsURL = (businessUnitSlug: string, formId: string) => {
  return `${path}/${businessUnitSlug}/results/${formId}`;
};
